module.exports = __webpack_public_path__ + "img/home-brands-barilla.jpg?9d7b4d1ff0d73e9e371f4d9a0401a972";